export const normalizeItems = (items = []) => {
  if (!items.length) return [];
  if (items.some((item) => Array.isArray(item.items))) {
    return items.flatMap((group) => group.items || []);
  }
  return items;
};

